/* eslint-disable prefer-template */
import { PAGE_NAME } from '../../../server/constants';

export const EventTypes = {
    pageView: PAGE_NAME + '.page_view',
    applicationSubmit: PAGE_NAME + '.application_submit',
};
